import { GlobalStore } from "../../../store/GlobalStore";
import { Redirect, useLocation, useHistory } from "react-router-dom";
import { getCookie, setCookie } from "../../../utils/cookie";
import { useEffect, useState, useRef } from "react";
import {
  IonApp,
  IonPage,
  IonToolbar,
  IonButtons,
  IonMenuToggle,
  IonButton,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonModal,
  IonItem,
  IonLabel,
  IonIcon,
} from "@ionic/react";
import UserLogout from "../../../components/UserLogoutComponent";
import { createBookingHandler } from "../services/handler";
import { getTripFare } from "../../newDelivery/services/handlers";

function ConfirmationSummary(props) {
  const modal = useRef(null);
  const modal1 = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [faliureModal, setFaliureModal] = useState(false);
  const [priceIdExpiredModal, setPriceIdExpiredModal] = useState(false);
  const [confirDeliveryAddress, setConfirmDeliveryAddress] = useState({});
  const [redirectToBooking, setRedirectToBooking] = useState(false);
  const [updatedDeliveryDetails, setUpdatedDeliveryDetails] = useState({})
  let history = useHistory();

  let deliverDetails =
    sessionStorage.getItem("deliveryAddresses") !== null
      ? JSON.parse(sessionStorage.getItem("deliveryAddresses"))
      : {};

  // const deliverDetails = getCookie('DeliveryDetails') !== "" ? JSON.parse(getCookie('DeliveryDetails')) : ""

  useEffect(() => {
    // const deliverDetails1 = JSON.parse(getCookie('DeliveryDetails'))
    // setConfirmDeliveryAddress(deliverDetails1)
  }, []);

  function dismiss() {
    modal.current.dismiss();
  }

  const handleBookingConfirmation = async () => {
    let resposne = await createBookingHandler(deliverDetails);
    if (resposne.status) {
      setIsOpen(true);
      sessionStorage.clear();
    } else if (resposne.error.code === 1004) {
        let response = await getTripFare(deliverDetails)
        setUpdatedDeliveryDetails({...deliverDetails ,
          tripFare:response.data.price[0].detail['9'].total ,
          currency: response.data.currency, 
          priceId:response.data.priceID,
          duration:response.data.directions.duration ,
          distance: response.data.directions.distance,
          geometry: response.data.directions.geometry,
          })
          setPriceIdExpiredModal(true)
        return
      }else {
      setFaliureModal(true);
      // Show modal to Redirect to payment method
    }
  };

  const handleUpdatedBookingConfirmation = async () => {
    let resposne = await createBookingHandler(updatedDeliveryDetails);
    if (resposne.status) {
      setIsOpen(true);
      setPriceIdExpiredModal(false)
      //setCookie("DeliveryDetails", "")
      sessionStorage.clear();
    } else {
      setFaliureModal(true);
      // Show modal to Redirect to payment method
    }
  };

  const handleExitNewPaymentMethod = () => {
    modal1.current.dismiss()
    setPriceIdExpiredModal(false);
                        
                        sessionStorage.clear()
                        modal.current.dismiss();
                        history.push("/booking");
                        setPriceIdExpiredModal(false)
  }

  return (
    <>
      <IonApp>
        <IonPage
          className="ion-page core-wrapper confirm-wrapper"
          id="main-content"
        >
          <IonToolbar className="header-toolbar">
            <IonButtons slot="start" className="home-btn">
              <IonMenuToggle>
                <IonButton>
                  <img src="../img/menu-icon.png" />
                </IonButton>
              </IonMenuToggle>
            </IonButtons>
            <img className="header-logo" src="../img/logo.png" />
          </IonToolbar>

          <IonContent className="ion-padding page-title">
            <div className="wrapper dashboard-page  option-1 option-1-1">
              <ion-breadcrumbs>
                <ion-breadcrumb href="new-delivery">
                  New Delivery
                </ion-breadcrumb>
                <ion-breadcrumb href="payment">Payments</ion-breadcrumb>
                <ion-breadcrumb href=""> Review & Confirm</ion-breadcrumb>
              </ion-breadcrumbs>
              <h1>Confirm Your Delivery</h1>

              <div className="payment desktop">
                <img src="../img/confirm.svg" />
              </div>
              <div className="payment mobile">
                <img src="../img/confirm.svg" />
              </div>

              <div className="summary">
                <IonGrid>
                  <IonRow>
                    {deliverDetails && (
                      <>
                        <IonCol size="7">
                          <h5>
                            Est Delivery Time{" "}
                            <b style={{ color: "black" }}>
                              {Math.round(deliverDetails.duration / 60)} mins
                            </b>
                          </h5>
                          <p>Pickup Location</p>
                          <h4>{deliverDetails.pickUpLocation.address}</h4>
                        </IonCol>
                        <IonCol size="5">
                          <h5>Total Fare</h5>
                          <h1>${deliverDetails.tripFare}</h1>
                          <p>
                            Inclusive of GST <br />
                            <b>Learn more</b> about our delivery charges
                          </p>
                        </IonCol>
                      </>
                    )}
                  </IonRow>
                </IonGrid>
              </div>
              {deliverDetails && (
                <>
                  <div className="accordion-wrapper confirm-summary order-summary">
                    <div>
                      {deliverDetails.pickUpLocation.address}
                      <span>
                        Unit : #{deliverDetails.pickUpLocation.floor}-
                        {deliverDetails.pickUpLocation.unitNumber} | Contact :{" "}
                        {deliverDetails.pickUpLocation.contactName} | Number :{" "}
                        {deliverDetails.pickUpLocation.contactNumber}{" "}
                      </span>{" "}
                    </div>

                    <div>
                      {" "}
                      {deliverDetails.dropOffLocation.address}
                      <span>
                        Unit : #{deliverDetails.dropOffLocation.floor}-
                        {deliverDetails.dropOffLocation.unitNumber} | Contact :{" "}
                        {deliverDetails.pickUpLocation.contactName} | Number :{" "}
                        {deliverDetails.dropOffLocation.contactNumber}{" "}
                      </span>{" "}
                    </div>

                    {deliverDetails.additionalStops.map((stop) => {
                      return (
                        <div>
                          {stop.address}
                          <span>
                            Unit : #{stop.floor}-{stop.unitNumber} | Contact :{" "}
                            {stop.contactName} | Number :{" "}
                            {stop.contactNumber.substring(0, 4)}{" "}
                            {stop.contactNumber.substring(4, 8)}{" "}
                          </span>
                        </div>
                      );
                    })}
                  </div>{" "}
                </>
              )}

              <IonGrid>
                <IonRow>
                  <IonCol className="payment-next back ion-align-self-end left">
                    <IonButton
                      size="default"
                      mode="ios"
                      onClick={() => {
                        history.push("/payment");
                      }}
                    >
                      Back
                    </IonButton>
                  </IonCol>
                  <IonCol className="payment-next ion-align-self-end right">
                    <IonButton
                      color="primary"
                      size="default"
                      mode="ios"
                      onClick={handleBookingConfirmation}
                    >
                      Confirm
                    </IonButton>
                  </IonCol>
                </IonRow>
              </IonGrid>

              <IonModal
                isOpen={isOpen}
                ref={modal}
                onWillDismiss={(ev) => {
                  // history.push("/deliveries")
                }}
              >
                <IonContent className="ion-padding upload-csv confirm-modal">
                  <ion-icon
                    name="close-outline"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsOpen(false);
                      setRedirectToBooking(true);
                      history.push("/deliveries");
                      dismiss();
                    }}
                  ></ion-icon>

                  <img src="../img/payment-success.png" />
                  <h2> Payment Successful!</h2>
                  <IonButton
                      color="warning"
                      size="default"
                      mode="ios"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsOpen(false);
                       setRedirectToBooking(true);
                        history.push("/deliveries");
                        dismiss();
                      }}
                    >
                      Go To Deliveries
                    </IonButton>
                </IonContent>
              </IonModal>

              <IonModal isOpen={faliureModal} ionModalDidDismiss={() => {}}>
                <IonContent className="ion-padding upload-csv confirm-modal">
                  <ion-icon
                    name="close-outline"
                    onClick={() => setFaliureModal(false)}
                  ></ion-icon>
                  <h2 style={{ color: "black" }}> Payment Unsuccessful!</h2>
                  <IonCol className="payment-next ion-align-self-end right">
                    <IonButton
                      color="primary"
                      size="default"
                      mode="ios"
                      onClick={()=>{ history.push("/payment"); }}
                    >
                      Change Payment Method
                    </IonButton>
                </IonCol>
                </IonContent>
              </IonModal>

              <IonModal isOpen={priceIdExpiredModal} ref={modal1} ionModalDidDismiss={() => {}}>
                <IonContent className="ion-padding upload-csv confirm-modal">
                  <ion-icon
                    name="close-outline"
                    onClick={() => setPriceIdExpiredModal(false)}
                  ></ion-icon>
                  <h2 style={{ color: "black" }}>Price has Expired!</h2>
                  <p>The current booking price has expired. Do you want to continue with new booking price of {updatedDeliveryDetails.currency }{updatedDeliveryDetails.tripFare} ? </p>
                  <IonCol className="payment-next ion-align-self-end right">
                  <IonButton
                      color="warning"
                      size="default"
                      mode="ios"
                      onClick={() => {
                        handleExitNewPaymentMethod()
                      }}
                    >
                      No
                    </IonButton>
                    </IonCol>
                    <IonCol className="payment-next ion-align-self-end right">
                  <IonButton
                      color="primary"
                      size="default"
                      mode="ios"
                      onClick={handleUpdatedBookingConfirmation}
                    >
                      Yes
                    </IonButton>
                    </IonCol>
                </IonContent>
              </IonModal>


            </div>
          </IonContent>
        </IonPage>
      </IonApp>
      {redirectToBooking && <Redirect to="/deliveries" />}
    </>
  );
}

export default ConfirmationSummary;
